import { PersonaLadder, Pathway, PositionLevel } from '../../models';
import { PERSONA_LADDER } from '../prototype/personas-data';
import { POSITION_PATHWAYS } from '../prototype/position-pathways-data';
import { DIVISIONS } from '../prototype/divisions-data';

/** The prototype names a pathway's division; the model holds its id. */
function divisionIdByName(name: string): string {
  const hit = Object.values(DIVISIONS as Record<string, { id: string; name: string }>).find((d) => d.name === name);
  return hit?.id ?? '';
}

/**
 * Career-pathway pathways — mapped from the prototype POSITION_PATHWAYS
 * (source of truth). Names, tracks, philosophies, and tier levels come straight
 * from the prototype.
 */
export const POSITION_PATHWAYS_SEED: readonly Pathway[] = Object.values(
  POSITION_PATHWAYS as Record<string, any>,
).map(
  (f): Pathway => ({
    id: f.id,
    name: f.name ?? '',
    divisionId: divisionIdByName(f.division ?? ''),
    pathway: f.pathway ?? '',
    // Filled from the seeded position catalogue when the slice loads — the
    // prototype kept a seat's pathway on the seat.
    seats: [],
    levels: (Array.isArray(f.levels) ? f.levels : []).map(
      (l: any): PositionLevel => ({
        tier: l.tier,
        label: l.label ?? '',
        reqYears: l.reqYears ?? '',
        salaryBand: l.salaryBand ?? '',
        whatYouDo: l.whatYouDo ?? '',
        requirements: Array.isArray(l.requirements) ? l.requirements : [],
        nextLevel: l.nextLevel ?? [],
      }),
    ),
  }),
);

/** Per-persona ladder placement — mapped from the prototype PERSONA_LADDER. */
export const PERSONA_LADDERS_SEED: readonly PersonaLadder[] = Object.entries(
  PERSONA_LADDER as Record<string, any>,
).map(
  ([personaId, v]): PersonaLadder => ({
    personaId,
    pathwayId: v.pathwayId,
    currentTier: v.currentTier,
  }),
);
